// У каждого личного кабинета своё руководство пользователя
const manuals = {
  scrap: 'https://help.mozen.ru/141--mozenscrap/',
  auto: 'https://help.mozen.ru/198--mozenauto/',
  app: 'https://help.mozen.ru/206--mozenapp/'
}

export const userManualDomains = {
  'app.mozenscrap.ru': {
    url: manuals.scrap
  },
  'app.mozenauto.ru': {
    url: manuals.auto
  },
  'app.mozen.io': {
    url: manuals.app
  },
  'localhost': {
    url: manuals.scrap
  }
}

// Тестовые стенды (full., light. и т.п.) живут на тех же корневых доменах, что и боевые кабинеты
const rootDomains = [
  {suffix: 'mozenauto.ru', url: manuals.auto},
  {suffix: 'mozen.io', url: manuals.app},
  {suffix: 'mozenscrap.ru', url: manuals.scrap}
]

export function getUserManualUrl(hostname = window.location.hostname) {
  const exactMatch = userManualDomains[hostname]

  if (exactMatch) {
    return exactMatch.url
  }

  const rootMatch = rootDomains.find(({suffix}) => hostname === suffix || hostname.endsWith(`.${suffix}`))

  return rootMatch ? rootMatch.url : manuals.scrap
}
